export default __webpack_public_path__ + "static/media/instagram-logo.dece9ae3.png";